import { CoreStatusExtended } from 'api-paths-cas';

interface IOption {
  label: string;
  value: string;
  populate?: {
    theme?: any;
    options: IOption[];
  };
}

export const configStagesSerializer = (
  stages: CoreStatusExtended[],
  isPathwayProvider: boolean,
  processedByUni?: boolean,
): IOption[] => {
  return stages.map(stage => {
    if (isPathwayProvider) {
      return isPathwayProviderConfigStageSerializer(stage, processedByUni);
    }
    return { label: stage, value: stage };
  });
};

export const isPathwayProviderConfigStageSerializer = (
  stage: CoreStatusExtended,
  processedByUni?: boolean,
): IOption => {
  switch (stage) {
    case CoreStatusExtended.PATHWAY_REVIEW: {
      return {
        label: 'Uni Review',
        value: CoreStatusExtended.PATHWAY_REVIEW,
      };
    }
    case CoreStatusExtended.READY_FOR_CAS: {
      return {
        label: processedByUni ? CoreStatusExtended.READY_FOR_CAS : 'Uni Processing',
        value: CoreStatusExtended.READY_FOR_CAS,
      };
    }
    default: {
      return { label: stage, value: stage };
    }
  }
};
